import ApplicationLayout from "./components/layout/ApplicationLayout";
import { ApplicationContextProvider } from "./context/ApplicationContext";
import { ThemeContextProvider } from "./context/ThemeContext";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { APP_URL } from "./constant/ApplicationVariables";
import { AppErrorBoundary } from "./components/errorFallback";
import GlobalSnackbar from "./components/common/GlobalSnackbar";

function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter basename={APP_URL.base_url}>
        <ThemeContextProvider>
          <ApplicationContextProvider>
            <ApplicationLayout />
            <GlobalSnackbar /> 
          </ApplicationContextProvider>
        </ThemeContextProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}

export default App;